<template>
  <div class="modal-background">
    <div class="modal-container">
      <div class="modal-title">
        <div class="is-18b">신청기간 마감 안내</div>
        <svg
          class="close-icon cursor"
          @click="$emit('close')"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M19 5.5L5 19.5M19 19.5L5 5.5" stroke="#646464" stroke-width="2" stroke-linecap="round" />
        </svg>
      </div>
      <div class="modal-content">
        <div class="is-16m">
          신청기간이 지났습니다.
          <br />
          <br />
          담당자에게 유선으로 문의하여 주시기 바랍니다.
          <br />
          <br />
          Tel 02)2268-2504
          <br />
        </div>
      </div>
      <div class="btn-wrap">
        <div class="cancel-btn is-16b" @click="$emit('close')">닫기</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MembershipIsClosedModal',
  mounted() {
    document.body.style.overflow = 'hidden'
  },
  unmounted() {
    document.body.style.overflow = 'auto'
  },
}
</script>

<style scoped lang="scss">
.modal-background {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #0f0f0f50;
  z-index: 100;
}

.modal-container {
  width: 700px;
  max-height: calc(100% - 64px);
  padding: 24px;
  background: #ffffff;

  .modal-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid #151515;
  }

  .modal-content {
    display: flex;
    flex-direction: column;

    .color {
      text-decoration: underline;
      cursor: pointer;
      color: #0058aa;
    }
  }

  .btn-wrap {
    margin-top: 24px;
    display: flex;
    align-items: center;
    gap: 16px;

    .cancel-btn {
      width: 100%;
      padding: 8px 0;
      border-radius: 4px;
      text-align: center;
      background: #f5f5f5;
      color: #646464;
      cursor: pointer;
    }

    .link-btn {
      width: 50%;
      padding: 8px 0;
      border-radius: 4px;
      text-align: center;
      background: #0058aa;
      color: white;
      cursor: pointer;
    }
  }
}
</style>
